import { ISimulacion } from './simulacion.model';

export interface ICuota {
  id?: number;
  numero?: number | null;
  periodo?: string | null;
  desembolso?: number | null;
  saldo?: number | null;
  capital?: number | null;
  interes?: number | null;
  valorCuota?: number | null;
  simulacion?: ISimulacion | null;
}

export class Cuota implements ICuota {
  constructor(
    public id?: number,
    public numero?: number | null,
    public periodo?: string | null,
    public desembolso?: number | null,
    public saldo?: number | null,
    public capital?: number | null,
    public interes?: number | null,
    public valorCuota?: number | null,
    public simulacion?: ISimulacion | null
  ) {}
}
